export default __webpack_public_path__ + "static/media/logo-mono.013990ff.svg";